import React from 'react';
import {
  string, node,
} from 'prop-types';
import classnames from 'classnames';
import Grid from '@active/react-ui/Grid';

const ContainerContent = ({
  className,
  children,
}) => {
  const classes = classnames({
    'checkout-ui-container__content': true,
  }, className);
  return (
    <Grid className={classes}>
      {children}
    </Grid>
  );
};

ContainerContent.propTypes = {
  children: node,
  className: string,
};

export default ContainerContent;
